module.exports = __webpack_public_path__ + "img/94.63920ee0.jpg";